import { action } from '@ember/object';
import Component from '@glimmer/component';

import FormRadiobuttonGroupComponent from 'webapp/components/form/radiobutton-group';

interface FormatOption {
	value: boolean;
	label: string;
	// isSelected: boolean;
}

interface Args {
	isPageless: boolean;
	onChange: (value: boolean) => void;
}

export default class BoardsShareScheduleFormatSwitcherComponent extends Component<Args> {
	get formatOptions(): FormatOption[] {
		return [
			{
				value: true,
				label: 'Page',
				// isSelected: this.args.isPageless,
			},
			{
				value: false,
				label: 'Slides',
				// isSelected: !this.args.isPageless,
			},
		];
	}

	@action
	onChange(value: AnySimpleValue): void {
		this.args.onChange(value as boolean);
	}
	<template>
		<div class="row row--radiobuttons">
			<label>Export format</label>
			<div class="right">
				<FormRadiobuttonGroupComponent
					class="radiobutton-default"
					@name="format"
					@selected={{@isPageless}}
					@options={{this.formatOptions}}
					@isRequired={{true}}
					@onChange={{this.onChange}}
				/>
			</div>
			{{!-- <div class="view-switcher">
        {{#each this.formatOptions as |option|}}
            <a
                role="button"
                class="button switcher-btn {{if option.isSelected "theme-blue" "theme-grey-outlined"}}"
                {{on "click" (fn @onChange option.value)}}
            >
                {{option.label}}
            </a>
        {{/each}}
    </div> --}}
		</div>
	</template>
}
